'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var graphicsHelper = require('./../../helper/graphicsHelper');
var styleHelper = require('./../../helper/styleHelper');

var VideoPlayer = React.createClass({
  render: function () {
    return (
      <div className="video-player-content">
        <div className="bottom">
          <canvas ref="canvas" style={{width:'100%',height:'100%'}} width={styleHelper.getWidth(this.props) - 4} height={27} >
            <img ref="img" src={assetsHelper.getComponentAsset('videoplayer')}
                 onLoad={this.onImageLoaded}/>
          </canvas>
        </div>
      </div>
    );
  },

  componentDidMount: function () {
    this.paint();
  },

  componentDidUpdate: function () {
    this.paint();
  },

  onImageLoaded: function () {
    this.isLoaded = true;
    this.paint();
  },

  componentWillUnmount : function(){
    if(this.requestID){
      cancelAnimationFrame(this.requestID);
    }
  },

  paint: function () {
    if (this.isLoaded) {
      this.requestID = window.requestAnimationFrame(this.doPaint);
    }
  },

  doPaint: function () {
    var canvas = ReactDOM.findDOMNode(this.refs.canvas).getContext('2d');
    var img = ReactDOM.findDOMNode(this.refs.img);
    var img9 = {
      left: 100,
      right: 120
    };
    //canvas.canvas.width = this.props.w - 4;
    //canvas.canvas.height = 27;
    graphicsHelper.drawHorizontalThreeGridImage(canvas,img,150,151,{left :0,top : 0,right : this.props.w - 4,bottom : 27});
    //graphicsHelper.drawNineGridImage(canvas,img,img9,{left :0,top : 0,right : this.props.w,bottom : 27});
  }
});

module.exports = VideoPlayer;



// WEBPACK FOOTER //
// ./src/views/Components/VideoPlayer.jsx